import React, { lazy } from 'react';
// WhatYouGet.tsx

// Imágenes individuales por tomo — cambiá cada constante para subir su imagen propia
const TOMO_1_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779122413/ChatGPT_Image_18_may_2026_01_39_51_p.m_sfcdgi.webp';
const TOMO_2_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779122533/ChatGPT_Image_18_may_2026_01_41_53_p.m_rtofyi.webp';
const TOMO_3_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779122614/ChatGPT_Image_18_may_2026_01_42_56_p.m_dsyhtw.webp';
const TOMO_4_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779122677/ChatGPT_Image_18_may_2026_01_44_11_p.m_1_eyimyl.webp';
const TOMO_5_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779122735/ChatGPT_Image_18_may_2026_01_45_04_p.m_rql1ym.webp';
const TOMO_6_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779122785/ChatGPT_Image_18_may_2026_01_46_05_p.m_xuuwnv.webp';
const tomes = [{
  number: '01',
  title: 'Anatomía, Fisiología y Bioquímica para Nutrición',
  desc: 'Bases del cuerpo humano, sistemas, metabolismo celular y bioquímica aplicada a la carrera.',
  emoji: '🧬',
  image: TOMO_1_IMG
}, {
  number: '02',
  title: 'Nutrición Normal y Alimentación Saludable',
  desc: 'Macronutrientes, micronutrientes, requerimientos, GAPA y alimentación en todas las etapas de vida.',
  emoji: '🥗',
  image: TOMO_2_IMG
}, {
  number: '03',
  title: 'Alimentos, Bromatología y Técnica Dietética',
  desc: 'Composición de alimentos, conservación, higiene, CAA y técnicas de preparación.',
  emoji: '🍎',
  image: TOMO_3_IMG
}, {
  number: '04',
  title: 'Evaluación Nutricional y Dietoterapia',
  desc: 'Antropometría, indicadores clínicos, diagnóstico nutricional y planes para las patologías más frecuentes.',
  emoji: '📋',
  image: TOMO_4_IMG
}, {
  number: '05',
  title: 'Salud Pública y Nutrición Comunitaria',
  desc: 'Epidemiología nutricional, políticas alimentarias, ENNyS, EAN y programas nacionales.',
  emoji: '🏥',
  image: TOMO_5_IMG
}, {
  number: '06',
  title: 'Investigación, Gestión y Práctica Profesional',
  desc: 'Metodología de investigación, bioestadística, gestión en servicios de alimentación y ejercicio profesional.',
  emoji: '🎓',
  image: TOMO_6_IMG
}];
const bonuses = [{
  emoji: '📏',
  title: 'Guía Práctica de Antropometría'
}, {
  emoji: '🥦',
  title: 'Tablas de Porciones e Intercambios'
}, {
  emoji: '🧮',
  title: 'Guía de Cálculos Nutricionales'
}, {
  emoji: '📖',
  title: 'Guía Rápida de Conceptos de Nutrición'
}, {
  emoji: '✅',
  title: 'Preguntas de Examen y Repaso'
}, {
  emoji: '📋',
  title: 'Plantillas de Estudio y Seguimiento'
}];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(220,252,231) 0%, rgb(240,253,244) 50%, rgb(255,255,255) 100%)'
  }} data-id="element-411">
      <div className="mx-auto max-w-4xl" data-id="element-412">
        {/* Label */}
        <div className="flex items-center justify-center gap-2 mb-2" data-id="element-413">
          <span className="h-px w-8 bg-green-400" data-id="element-414" />
          <p className="text-xs sm:text-sm font-bold tracking-[2px] uppercase text-green-700 m-0" data-id="element-415">
            El producto base
          </p>
          <span className="h-px w-8 bg-green-400" data-id="element-416" />
        </div>

        {/* Heading */}
        <h2 className="text-2xl sm:text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-417">
          Megapack Nutrición:{' '}
          <span className="text-green-700" data-id="element-418">Carrera Resuelta™</span>
        </h2>

        <p className="text-center text-sm text-gray-500 m-0 mb-2" data-id="element-419">
          6 tomos · 6 bonos · +360 páginas
        </p>

        <p className="text-center text-sm text-gray-600 mx-auto max-w-lg m-0 mb-8" data-id="element-420">
          El contenido central de toda la carrera, armado sobre los planes de
          estudio oficiales y organizado por ejes curriculares.{' '}
          <strong className="text-gray-800" data-id="element-421">
            Sin buscar más. Sin improvisar.
          </strong>
        </p>

        {/* Tomos */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-422">
          <div className="bg-green-700 px-5 py-2.5 flex items-center justify-between gap-3" data-id="element-423">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-424">
              📚 Los 6 Tomos
            </h3>
            <span className="shrink-0 text-[10px] font-bold text-green-200 bg-green-800 rounded-full px-2 py-0.5 whitespace-nowrap" data-id="element-425">
              +360 páginas
            </span>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-426">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-427">
                <span className="shrink-0 text-xl w-8 text-center" data-id="element-428">
                  {tome.emoji}
                </span>
                <div className="flex-1 min-w-0" data-id="element-429">
                  <span className="block text-xs font-black text-gray-900" data-id="element-430">
                    Tomo {tome.number} — {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-431">
                    {tome.desc}
                  </span>
                </div>
                {/* Imagen referencial */}
                <div className="shrink-0 w-16 h-12 rounded-lg overflow-hidden border border-green-100" data-id="element-432">
                  <img src={tome.image} alt={`Tomo ${tome.number}`} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-433" />
                </div>
              </div>)}
          </div>
        </div>

        {/* Bonos */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-434">
          <div className="bg-green-700 px-5 py-2.5 flex items-center justify-between gap-3" data-id="element-435">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-436">
              🎁 Los 6 Bonos incluidos
            </h3>
            <span className="shrink-0 text-[10px] font-bold text-green-200 bg-green-800 rounded-full px-2 py-0.5 whitespace-nowrap" data-id="element-437">
              GRATIS
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 divide-gray-100" data-id="element-438">
            {bonuses.map((bonus, i) => <div key={bonus.title} className={`flex items-center gap-3 px-5 py-3 ${i % 2 === 0 ? 'sm:border-r border-gray-100' : ''} ${i < bonuses.length - 2 ? 'sm:border-b border-gray-100' : ''}`} data-id="element-439">
                <span className="text-lg shrink-0" data-id="element-440">{bonus.emoji}</span>
                <span className="text-xs font-semibold text-gray-800" data-id="element-441">
                  {bonus.title}
                </span>
              </div>)}
          </div>
        </div>

        {/* Tags footer */}
        <div className="rounded-xl px-5 py-3 flex flex-wrap gap-2 justify-center" style={{
        backgroundColor: 'rgb(220,252,231)',
        border: '1px solid rgba(34,197,94,0.3)'
      }} data-id="element-442">
          {['📄 100% PDF', '⚡ Acceso inmediato', '🇦🇷 Hecho para Argentina', '🏫 Compatible con UBA · UNC · UNLP · USAL y más'].map(tag => <span key={tag} className="text-[11px] font-semibold text-gray-700 bg-white border border-green-200 rounded-full px-2.5 py-1" data-id="element-443">
              {tag}
            </span>)}
        </div>
      </div>

      {/* Separador hacia siguiente producto */}
      <div className="mx-auto max-w-4xl mt-10 flex flex-col items-center gap-2" data-id="element-444">
        <p className="text-xs font-bold text-green-700 uppercase tracking-widest m-0" data-id="element-445">
          ¿Querés más que el contenido?
        </p>
        <p className="text-sm text-gray-600 text-center m-0" data-id="element-446">
          El Sistema Carrera Organizada™ agrega planificación y organización
          para toda tu cursada.
        </p>
        <div className="flex items-center gap-2 mt-1" data-id="element-447">
          <div className="h-px w-16 bg-green-300" data-id="element-448" />
          <span className="text-green-500 text-lg" data-id="element-449">↓</span>
          <div className="h-px w-16 bg-green-300" data-id="element-450" />
        </div>
      </div>
    </section>;
}